import { render, staticRenderFns } from "./advRangeLoss.vue?vue&type=template&id=2046ab6c&"
import script from "./advRangeLoss.vue?vue&type=script&lang=js&"
export * from "./advRangeLoss.vue?vue&type=script&lang=js&"
import style0 from "./advRangeLoss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2046ab6c')) {
      api.createRecord('2046ab6c', component.options)
    } else {
      api.reload('2046ab6c', component.options)
    }
    module.hot.accept("./advRangeLoss.vue?vue&type=template&id=2046ab6c&", function () {
      api.rerender('2046ab6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advRangeLoss.vue"
export default component.exports